// third party
import * as yup from 'yup';
import { format, isDate, isValid } from 'date-fns';

const validationSchema = (intl) =>
    yup
        .object()
        .shape({
            estimatedStartDate: yup
                .date()
                .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-estimatedstartdate-invalid' }))
                .nullable(),
            estimatedEndDate: yup
                .date()
                .typeError(intl.formatMessage({ id: 'ui-comp-formvalidation-estimatedenddate-invalid' }))
                .when('estimatedStartDate', (estimatedStartDate, schema) => {
                    if (isDate(estimatedStartDate) && isValid(estimatedStartDate)) {
                        return schema.min(
                            estimatedStartDate,
                            intl.formatMessage({
                                id: 'ui-comp-formvalidation-estimatedenddate-min',
                                values: { minValue: format(estimatedStartDate, 'd/MM/yyyy') }
                            })
                        );
                    }

                    return schema;
                })
                .nullable()
        })
        .nullable();

export default validationSchema;
